// rollMenu.js
var RollMenu = pc.createScript('rollMenu');

RollMenu.attributes.add('menuGfx', {type: 'entity', title: 'menuGfx', array: true});
RollMenu.attributes.add('menuNodes', {type: 'entity', title: 'menuNodes', array: true});

// initialize code called once per entity
RollMenu.prototype.initialize = function() {
    this.app.keyboard.on(pc.EVENT_KEYDOWN, this.onKeyDown, this);
    this.app.keyboard.on(pc.EVENT_KEYUP, this.onKeyUp, this);
    this.counter = 0;
    pMargin = 40;
    sMargin = 0.5;
    visibleNodes = 3;
    ent1 = null;
    ent2 = null;
    ent3 = null;
    ent4 = null;
    for(i = 0; i < this.menuGfx.length; i++){
        this.menuGfx[i].enabled = false;
    }
    this.goLeft();
};



RollMenu.prototype.calcWrap = function(val) {
    if(val < 0){
        if(val < -2){
            return this.menuGfx.length - 3;
        }
        if(val < -1){
           //this.app.fire('debug', 'case1: ', val, 2);
           return this.menuGfx.length - 2; 
        } else {
            //this.app.fire('debug', 'case2: ', val, 2);
            return this.menuGfx.length - 1;
        }
        
    }
    if(val > this.menuGfx.length - 1){
        if(val == this.menuGfx.length){
           return 0;
        }
        if(val == this.menuGfx.length + 1){
           return 1;
        }
  
    }
    return val;
};

RollMenu.prototype.goLeft = function() {
    
    this.counter -= 1;
    this.app.fire('rollMenu:this.counter', this.counter);
    this.counter = this.calcWrap(this.counter);

    ent1 = this.menuGfx[this.calcWrap(this.counter-1)];
    ent2 = this.menuGfx[this.counter];
    ent3 = this.menuGfx[this.calcWrap(this.counter+1)];
    ent4 = this.menuGfx[this.calcWrap(this.counter-2)];
    
    for(k = 0; k < this.menuGfx.length; k++){
        this.menuGfx[k].enabled = false;
    }
    
    var startPos = 0 - (visibleNodes / 2 - 0.5) * pMargin;
    var pos1 = new pc.Vec3(startPos,0,0);
    var pos2 = new pc.Vec3(startPos + pMargin,0,0);
    var pos3 = new pc.Vec3(startPos + (2 * pMargin),0,0);
        
    ent1.setLocalPosition(pos1);
    ent2.setLocalPosition(pos2);
    ent3.setLocalPosition(pos3);
    ent4.setLocalPosition(-80,0,0);
    
    ent1.enabled = true;
    ent2.enabled = true;
    ent3.enabled = true;
    ent4.enabled = true;

    this.transFormNodes(ent1, 2);
    this.transFormNodes(ent2, 1);
    this.transFormNodes(ent3, 0);
    this.transFormNodes(ent4, 3);
    
};

RollMenu.prototype.goRight = function() {
    
    this.counter += 1;
    this.app.fire('rollMenu:this.counter', this.counter);
    this.counter = this.calcWrap(this.counter);
    //this.app.fire('debug', 'this.counter', this.counter, 0);
    ent1 = this.menuGfx[this.calcWrap(this.counter-2)];
    ent2 = this.menuGfx[this.counter];
    ent3 = this.menuGfx[this.calcWrap(this.counter-1)];
    ent4 = this.menuGfx[this.calcWrap(this.counter-3)];
    
    for(l = 0; l < this.menuGfx.length; l++){
        this.menuGfx[l].enabled = false;
    }
    
    var startPos = 0 - (visibleNodes / 2 - 0.5) * pMargin;
    var pos1 = new pc.Vec3(startPos,0,0);
    var pos2 = new pc.Vec3(startPos + pMargin,0,0);
    var pos3 = new pc.Vec3(startPos + (2 * pMargin),0,0);
        
    ent1.setLocalPosition(pos2);
    ent2.setLocalPosition(80,0,0);
    ent3.setLocalPosition(pos3);
    ent4.setLocalPosition(-40,0,0);
    
    ent1.enabled = true;
    ent2.enabled = true;
    ent3.enabled = true;
    ent4.enabled = true;

    this.transFormNodes(ent1, 3);
    this.transFormNodes(ent2, 1);
    this.transFormNodes(ent3, 2);
    this.transFormNodes(ent4, 4);
};


RollMenu.prototype.transFormNodes = function(ent, order){
    
    var that = this;
    var data = {xPos: 0, scale: 0};
    var trgtPos = this.menuNodes[order].getLocalPosition().x;
    var trgtScl = this.menuNodes[order].getLocalScale().x;
    
    data.xPos = ent.getLocalPosition().x;
    data.scale = ent.getLocalScale().x;
    
    ent
        .tween(data)
        .to({xPos: trgtPos, scale: trgtScl}, 0.25, pc.QuinticOut)
        .on('update', function () {
           this.entity.setLocalPosition(data.xPos,0,0);
           this.entity.setLocalScale(data.scale, data.scale, data.scale);
        })
        .on('complete', function () {
            })
        .start();
};


// update code called every frame
RollMenu.prototype.update = function(dt) {
  if (this.app.keyboard.wasPressed(pc.KEY_LEFT)) {
      this.goLeft();
    } else if (this.app.keyboard.wasPressed(pc.KEY_RIGHT)) {
      this.goRight();
    }
};

// swap method called for script hot-reloading
// inherit your script state here
// RollMenu.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

